<template>
  <div class="session">
    <session-navbar
      :name="profile ? profile.firstname : null"
      :localtime="otherUserTime"
      :countdown="null"
      :roomId="roomId"
    />
    <div style="height: 60px"></div>
    <div class="session-content" dir="rtl">
      <div v-if="connectionState === 'connected'">
        <video
          id="remoteVideo"
          class="remote-video"
          v-observe-visibility="remoteVideo"
          autoplay
        ></video>
        <!-- <div class="take-note" v-b-modal.modal-center @click="newNote = true">
          <span>+</span>
          <span>Take a Note</span>
        </div>

        <div class="notes-area">
          <notes
            v-for="(note, index) in notes"
            :key="index"
            :content="note.note"
            :activeColor="note.color"
            :ni="index"
            @changeNoteColor="changeColor"
            @editMe="modalValue"
            @deleteMe="deleteNote"
          />
        </div> -->
      </div>
      <div
        v-if="connectionState !== 'connected' || otherUserCameraMuted"
        class="profile__session"
      >
        <img
          v-if="session.user.imgURL"
          :src="session.user.imgURL"
          alt="User Image"
        />
        <h3>{{ session.user.firstname }}</h3>
        <button
          @click="notify()"
          v-if="!otherUserCameraMuted"
          class="btn btn-primary"
        >
          Notify
        </button>
      </div>
      <!-- Notes under the remote video -->
      <!-- <div class="take-note" v-b-modal.modal-center @click="newNote = true">
        <span>+</span>
        <span>Take a Note</span>
      </div>
      <div class="notes-area">
        <notes
          v-for="(note, index) in notes"
          :key="index"
          :content="note.note"
          :activeColor="note.color"
          :ni="index"
          @changeNoteColor="changeColor"
          @editMe="modalValue"
          @deleteMe="deleteNote"
        />
      </div> -->
      <hsc-window-style-metal>
        <hsc-window
          title=""
          positionHint="20 / -200"
          :closeButton="true"
          :resizable="true"
          :minWidth="112.5"
          :minHeight="87"
          :maxWidth="450"
          :maxHeight="348"
        >
          <video
            id="localVideo"
            class="local-video"
            muted
            autoplay
            playsinline
            style="background-color: #8D99A0"
            :key="refresh"
            v-observe-visibility="localVideo"
          ></video>
          <div class="local-levels">
            <svg
              v-if="muteMic"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.3999 5.3C16.3999 4.58203 16.9819 4 17.6999 4C18.4179 4 18.9999 4.58203 18.9999 5.3V18.3C18.9999 19.018 18.4179 19.6 17.6999 19.6C16.9819 19.6 16.3999 19.018 16.3999 18.3V5.3Z"
                fill="none"
              />
              <path
                d="M6 14.4C6 13.682 6.58203 13.1 7.3 13.1C8.01797 13.1 8.6 13.682 8.6 14.4V18.3C8.6 19.018 8.01797 19.6 7.3 19.6C6.58203 19.6 6 19.018 6 18.3V14.4Z"
                fill="none"
              />
              <path
                d="M11.2002 9.20001C11.2002 8.48204 11.7822 7.90001 12.5002 7.90001C13.2182 7.90001 13.8002 8.48204 13.8002 9.20001V18.3C13.8002 19.018 13.2182 19.6 12.5002 19.6C11.7822 19.6 11.2002 19.018 11.2002 18.3V9.20001Z"
                fill="none"
              />
            </svg>
            <svg
              v-if="!muteMic"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="localAudio3"
                d="M16.3999 5.3C16.3999 4.58203 16.9819 4 17.6999 4C18.4179 4 18.9999 4.58203 18.9999 5.3V18.3C18.9999 19.018 18.4179 19.6 17.6999 19.6C16.9819 19.6 16.3999 19.018 16.3999 18.3V5.3Z"
                fill="none"
              />
              <path
                id="localAudio1"
                d="M6 14.4C6 13.682 6.58203 13.1 7.3 13.1C8.01797 13.1 8.6 13.682 8.6 14.4V18.3C8.6 19.018 8.01797 19.6 7.3 19.6C6.58203 19.6 6 19.018 6 18.3V14.4Z"
                fill="none"
              />
              <path
                id="localAudio2"
                d="M11.2002 9.20001C11.2002 8.48204 11.7822 7.90001 12.5002 7.90001C13.2182 7.90001 13.8002 8.48204 13.8002 9.20001V18.3C13.8002 19.018 13.2182 19.6 12.5002 19.6C11.7822 19.6 11.2002 19.018 11.2002 18.3V9.20001Z"
                fill="none"
              />
            </svg>
          </div>
        </hsc-window>
      </hsc-window-style-metal>
      <hsc-window-style-metal v-if="sharingScreen">
        <hsc-window
          title=""
          positionHint="20 / -200"
          :closeButton="true"
          :resizable="true"
          :minWidth="112.5"
          :minHeight="87"
          :maxWidth="450"
          :maxHeight="348"
        >
          <video
            id="sharedScreen"
            class="local-video"
            muted
            autoplay
            playsinline
            style="background-color: #8D99A0"
            :key="refresh"
            v-observe-visibility="sharedScreen"
          ></video>
        </hsc-window>
      </hsc-window-style-metal>

      <transition name="fade">
        <session-settings
          v-if="setting"
          class="settings"
          :micLabel="micLabel"
          :cameraLabel="cameraLabel"
          @change-audio-input="changeAudioInput"
          @change-audio-output="changeAudioOutput"
          @change-video-input="changeVideoInput"
        />
      </transition>
    </div>
    <controls-bar
      :name="session.user.firstname"
      :plan="session.plan.title"
      :img="session.user.imgURL"
      :connectionState="connectionState"
      :remoteStream="remoteStream"
      :muteMic="muteMic"
      :muteCamera="muteCamera"
      :otherUserMicMuted="otherUserMicMuted"
      :sharingScreen="sharingScreen"
      :setting="setting"
      @toggle-audio="handleToggleAudio"
      @toggle-video="handleToggleVideo"
      @share-screen="handleShareScreen"
      @show-setting="setting = !setting"
      @toggle-chat="showChat = !showChat"
      @end-sessions="leaveSession"
    />
    <div class="overlay" @click="setting = false" v-if="setting"></div>
    <Canvas :room-id="roomId" :profile="profile" :remote-user="session.user" />
    <chat
      :room-id="roomId"
      :profile="profile"
      :remote-user="session.user"
      :show-chat="showChat"
      :chats="chats"
      @send-message="handleSendMsg"
      @close-chat="showChat = false"
    />
    <b-modal id="modal-center" centered title="Your Note" @ok="saveNote">
      <div class="input-note">
        <textarea class="form-control" v-model="note" rows="4"></textarea>
      </div>
    </b-modal>
    <Fireworks v-if="conjureFireworks" :boxHeight="'100%'" :boxWidth="'100%'" />
  </div>
</template>

<script>
import Vue from "vue";
import * as VueWindow from "@hscmap/vue-window";
import VueObserveVisibility from "vue-observe-visibility";
import SessionNavbar from "../sessionNavbar";
import SessionSettings from "../sessionSettings";
import Chat from "./chat";
import Canvas from "./canvas";
// import Notes from "./notes";
import ControlsBar from "./controlsBar";
import { saveAs } from "file-saver";
import sendNotification from "@/services/sendNotification";
import VueConfetti from "vue-confetti";
import Fireworks from "./conjures/fireworks";
import { mapGetters } from "vuex";
import moment from "moment";

Vue.use(VueObserveVisibility);
Vue.use(VueConfetti);
Vue.use(VueWindow);

export default {
  name: "SessionRoom",
  components: {
    SessionNavbar,
    SessionSettings,
    Chat,
    Canvas,
    // Notes,
    ControlsBar,
    Fireworks
  },
  computed: {
    ...mapGetters({
      canvas: "session/canvas",
      conjure: "session/conjure"
    })
  },
  props: {
    session: {
      type: Object,
      required: true
    },
    localStream: {
      required: true
    },
    remoteStream: {
      required: true
    },
    roomId: {
      type: String,
      required: true
    },
    profile: {
      type: Object,
      required: true
    },
    signalingState: {
      required: true
    },
    connectionState: {
      required: true
    },
    iceConnectionState: {
      required: true
    },
    iceGatheringState: {
      required: true
    },
    dataChannel: {
      required: true
    },
    muteMic: {
      required: true
    },
    muteCamera: {
      required: true
    },
    otherUserMicMuted: {
      required: true
    },
    otherUserCameraMuted: {
      required: true
    },
    otherUserTime: {
      required: true
    },
    displayStream: {
      required: true
    },
    sharingScreen: {
      required: true
    },
    refresh: {
      required: true
    },
    caller: {
      required: true
    },
    callee: {
      required: true
    },
    micLabel: {
      required: true
    },
    cameraLabel: {
      required: true
    },
    chats: {
      required: true,
      default: () => {
        return [];
      }
    }
  },
  mounted() {
    this.conjureTS = moment().unix();
  },
  methods: {
    handleSendMsg(msg) {
      this.$emit("send-message", msg);
    },
    localVideo(isVisible, entry) {
      if (isVisible) {
        if (document.querySelector("#localVideo")) {
          document.querySelector("#localVideo").srcObject = this.localStream;
        }
      }
      console.log("Entry is:", entry);
    },
    remoteVideo(isVisible, entry) {
      if (isVisible) {
        if (document.querySelector("#remoteVideo")) {
          document.querySelector("#remoteVideo").srcObject = this.remoteStream;
        }
      }
      console.log("Entry is:", entry);
    },
    sharedScreen(isVisible, entry) {
      if (isVisible) {
        if (document.querySelector("#sharedScreen")) {
          document.querySelector(
            "#sharedScreen"
          ).srcObject = this.displayStream;
        }
      }
      console.log("Entry is:", entry);
    },
    changeAudioInput(source) {
      this.$emit("change-audio-input", source);
    },
    changeAudioOutput(source) {
      this.$emit("change-audio-output", source);
    },
    changeVideoInput(source) {
      this.$emit("change-video-input", source);
    },
    handleToggleAudio() {
      this.$emit("toggle-audio");
    },
    handleToggleVideo() {
      this.$emit("toggle-video");
    },
    notify() {
      console.log(this.session.user.user_id.id);
      sendNotification(
        `Join the Session ${this.session.plan.title} with ${this.session.user.firstame}.`,
        [this.session.user.user_id.id],
        ["email", "sms"],
        `Hey ${this.session.user.firstame}, I am inside Session Room. Can you Join? Thanks`,
        "Jounrey Binder"
      )
        .then(res => {
          console.log("sent", res);
        })
        .catch(e => {
          console.log("error", e);
        });
    },
    leaveSession() {
      if (this.localAudio) {
        this.localAudio.close();
      }

      this.$emit("hang-up");
      if (document.querySelector("#remoteVideo")) {
        document.querySelector("#remoteVideo").srcObject = null;
      }
    },
    handleShareScreen() {
      this.$emit("share-screen");
    },
    captureScreenShot() {
      const video = document.querySelector("#remoteVideo");
      var canvas = document.querySelector("#downloadCanvas");
      var photo = document.querySelector("#screenShot");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, canvas.width, canvas.height);
      var data = canvas.toDataURL("image/png");
      photo.setAttribute("src", data);
      this.screenShot = true;
      this.downloadScreenShot();
    },
    downloadScreenShot() {
      var canvas = document.querySelector("#downloadCanvas");
      var photo = document.querySelector("#screenShot");
      canvas.toBlob(blob => {
        saveAs(blob, "screenshot.png");
        this.screenShot = false;
        photo.setAttribute("src", null);
      });
    },
    startRecording() {
      if (!this.recording) {
        try {
          let options = { mimeType: "video/webm;codecs=vp9,opus" };
          if (!MediaRecorder.isTypeSupported(options.mimeType)) {
            console.error(`${options.mimeType} is not supported`);
            options = { mimeType: "video/webm;codecs=vp8,opus" };
            if (!MediaRecorder.isTypeSupported(options.mimeType)) {
              console.error(`${options.mimeType} is not supported`);
              options = { mimeType: "video/webm" };
              if (!MediaRecorder.isTypeSupported(options.mimeType)) {
                console.error(`${options.mimeType} is not supported`);
                options = { mimeType: "" };
              }
            }
          }
          this.mediaRecorder = new MediaRecorder(this.localStream, options);
          console.log("Created MediaRecorder");
        } catch (e) {
          console.error("Exception while creating MediaRecorder", e);
          return;
        }

        this.mediaRecorder.onstop = event => {
          console.log("Recorder stopped: ", event);
          console.log("Recorded Blobs: ", this.recordedBlobs);
        };
        this.mediaRecorder.ondataavailable = event => {
          console.log("Data Availabe", event);
          if (event.data && event.data.size > 0) {
            this.recordedBlobs.push(event.data);
          }
        };
        this.mediaRecorder.start();
        this.recording = true;
        console.log("MediaRecorder started", this.mediaRecorder);
      } else {
        this.mediaRecorder.stop();
        this.recording = false;
      }
    },
    downloadRecording() {
      const blob = new Blob(this.recordedBlobs, { type: "video/webm" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = "test.webm";
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.recordedBlobs = [];
      }, 100);
    },
    renderMeter() {
      var max_level_L = 0;
      var old_level_L = 0;
      this.localAudio = new AudioContext();
      var microphone = this.localAudio.createMediaStreamSource(
        this.localStream
      );
      var javascriptNode = this.localAudio.createScriptProcessor(1024, 1, 1);
      microphone.connect(javascriptNode);
      javascriptNode.connect(this.localAudio.destination);
      javascriptNode.onaudioprocess = function(event) {
        var inpt_L = event.inputBuffer.getChannelData(0);
        var instant_L = 0.0;

        var sum_L = 0.0;
        for (var i = 0; i < inpt_L.length; ++i) {
          sum_L += inpt_L[i] * inpt_L[i];
        }
        instant_L = Math.sqrt(sum_L / inpt_L.length);
        max_level_L = Math.max(max_level_L, instant_L);
        instant_L = Math.max(instant_L, old_level_L - 0.008);
        old_level_L = instant_L;
        let percentage = (instant_L / max_level_L) * 100;
        if (percentage == 0) {
          if (document.getElementById("localAudio1")) {
            document.getElementById("localAudio1").style.fill = "none";
          }
          if (document.getElementById("localAudio2")) {
            document.getElementById("localAudio2").style.fill = "none";
          }
          if (document.getElementById("localAudio3")) {
            document.getElementById("localAudio3").style.fill = "none";
          }
        } else if (percentage > 0 && percentage < 30) {
          if (document.getElementById("localAudio1")) {
            document.getElementById("localAudio1").style.fill =
              "var(--theme-color)";
          }
          if (document.getElementById("localAudio2")) {
            document.getElementById("localAudio2").style.fill = "none";
          }
          if (document.getElementById("localAudio3")) {
            document.getElementById("localAudio3").style.fill = "none";
          }
        } else if (percentage > 30 && percentage < 60) {
          if (document.getElementById("localAudio1")) {
            document.getElementById("localAudio1").style.fill =
              "var(--theme-color)";
          }
          if (document.getElementById("localAudio2")) {
            document.getElementById("localAudio2").style.fill =
              "var(--theme-color)";
          }
          if (document.getElementById("localAudio3")) {
            document.getElementById("localAudio3").style.fill = "none";
          }
        } else if (percentage > 60) {
          if (document.getElementById("localAudio1")) {
            document.getElementById("localAudio1").style.fill =
              "var(--theme-color)";
          }
          if (document.getElementById("localAudio2")) {
            document.getElementById("localAudio2").style.fill =
              "var(--theme-color)";
          }
          if (document.getElementById("localAudio3")) {
            document.getElementById("localAudio3").style.fill =
              "var(--theme-color)";
          }
        }
      };
    },
    deleteNote(e) {
      this.notes.splice(e.ni, 1);
    },
    modalValue(e) {
      this.currentNote = e.ni;
      this.note = this.notes[e.ni].note;
    },
    saveNote() {
      if (this.newNote) {
        this.notes.push({ note: this.note, color: 1 });
        this.newNote = false;
        return;
      } else {
        this.notes[this.currentNote].note = this.note;
      }
      this.note = "";
    },
    changeColor(e) {
      this.notes[e.ni].color = e.ci;
    },
    performConjure(type, interval) {
      if (type === "fireworks") {
        this.conjureFireworks = true;

        this.timerId = setTimeout(() => {
          this.conjureFireworks = false;
        }, interval);
      } else {
        this.$confetti.start({
          particles: [
            {
              type: type
            }
          ],
          defaultColors: ["red", "pink", "#ba0000"]
        });
        this.timerId = setTimeout(() => {
          this.$confetti.stop();
        }, interval);
      }
    }
  },
  data() {
    return {
      timerId: null,
      conjureFireworks: false,
      conjureTS: false, //the last conjure or set when mounted.
      stream: null,
      setting: false,
      showChat: false,
      note: "",
      currentNote: 0,
      notes: [],
      newNote: false,
      screenShot: false,
      message: "",
      mediaRecorder: null,
      recordedBlobs: [],
      recording: false,
      localAudio: null
    };
  },
  watch: {
    conjure(newConjure, oldConjure) {
      let updatedTS = newConjure._updated_at
        ? newConjure._updated_at.seconds
        : 0;
      if (
        newConjure.type &&
        newConjure.interval &&
        this.conjureTS < updatedTS
      ) {
        this.performConjure(newConjure.type, newConjure.interval);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.session {
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    background: transparent;
  }
  .session-content {
    position: relative;
    background: #474d52;
    min-height: calc(100vh - 140px);
    width: calc(100vw);
    padding-top: 120px;
    .remote-video {
      width: 100%;
      height: 100%;
      margin-top: -190px;
    }
    .notes-area {
      float: right;
      margin-right: 24px;
      display: grid;

      grid-template-rows: 154px 154px;
      grid-gap: 10px;
      grid-template-columns: repeat(auto-fill, 144px);
      grid-auto-flow: column;
      justify-content: end;
      z-index: 500;
    }
    .take-note {
      cursor: pointer;
      position: absolute;
      top: 24px;
      right: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100px;
      height: 70px;
      background: rgba(255, 255, 255, 0.1);
      background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='white' stroke-width='2' stroke-dasharray='6' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");

      span {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #ffffff;
      }
      &:hover {
        box-shadow: 0px 0px 4px 0px #888;
      }
    }
  }
  .profile__session {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 104px;

    img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      cursor: pointer;
    }
    h3 {
      cursor: pointer;
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 33px;
      color: #ffffff;
    }
    button {
      padding: 0;
      width: 84px;
      height: 28px;
      background: var(--theme-color);
      border-radius: 4px;
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .local-video {
    width: 100%;
    height: 100%;
    z-index: 5;
    background-color: #8d99a0;
  }
  .local-levels {
    svg {
      position: absolute;
      left: 252px;
      bottom: 2px;
    }
  }
}
// @media (max-width: 991px) {
//   .local-video {
//     position: fixed !important;
//     width: 100px;
//     bottom: 105px !important;
//   }
// }

@media (max-width: 768px) {
  .session-content {
    display: flex;
    justify-content: center;
  }
  .session .session-content {
    padding-top: 180px;
  }
  .session .profile__session {
    top: 10px;
  }
  .session-content .notes-area {
    margin: 0 5%;
    grid-auto-flow: row !important;
    grid-template-columns: 144px span 144px !important;
    grid-template-rows: repeat(auto-fill, 154px) !important;
  }
}
@media (max-width: 560px) {
  .setting {
    bottom: 130px !important;
    width: 100%;
    min-width: unset;
    .settings .set__settings .form-control {
      width: 50%;
    }
  }
}
</style>
